import { useState, useEffect } from "react";
import { Menu as MenuIcon } from "@mui/icons-material";
import { styled, alpha } from "@mui/material/styles";
import {
  IconButton,
  Toolbar,
  AppBar as MuiAppBar,
  Box,
  Typography,
  MenuItem,
  Menu,
} from "@mui/material";
import { Route, Routes, useNavigate } from "react-router-dom";
import AccountCircle from "@mui/icons-material/AccountCircle";
import { useDispatch, useSelector } from "react-redux";
import { getLoggedUser, loggedOut } from "../../store/auth";

const drawerWidth = 240;

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const Search = styled("div")(({ theme }) => ({
  position: "relative",
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha(theme.palette.common.white, 1),
  "&:hover": {
    backgroundColor: alpha(theme.palette.common.white, 1),
  },
  width: "100%",
  [theme.breakpoints.up("sm")]: {
    marginRight: theme.spacing(4),
    width: "auto",
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
}));

const NavBar = (props) => {
  const { open, handleDrawerOpen } = props;
  const [auth, setAuth] = useState(true);
  const [anchorEl, setAnchorEl] = useState(null);
  const dispatch = useDispatch();
  const navigate = useNavigate()

  const loggedUser = useSelector(getLoggedUser);
  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleNav = () => {
    navigate("/profile")
    handleClose()
  };

  const handleLogout = () => {
    dispatch(loggedOut())
    navigate('/login');
  };

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position="fixed" open={open}>
        <Toolbar>
          <IconButton
            size="large"
            edge="start"
            color="inherit"
            aria-label="menu"
            sx={{ mr: 2 }}
            onClick={handleDrawerOpen}
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            <Routes>
              <Route path="/" element={"Dashboard"} />
              <Route path="profile" element={"Profile"} />
              <Route path="users" element={"Manage Users"} />
              <Route path="issues" element={"Manage Issues"} />
              <Route path="clients" element={"Manage Customers"} />
              <Route path="review" element={"Review Task"} />
              <Route path="clientApp" element={"Client Application"} />
            </Routes>
          </Typography>
          <Box sx={{ display: { xs: "none", md: "flex" } }}>
            {/* <Typography variant="p" component="div"
              sx={{ flexGrow: 1, mr: 3 }} alignContent="center">
              Customer Support Portal</Typography> */}
            <Typography variant="p" component="div"
              sx={{ flexGrow: 1, mr: 0 }} alignContent="center">
              {loggedUser?.username}</Typography>
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleMenu}
              color="inherit"
            >
              <AccountCircle />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorEl}
              anchorOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              open={Boolean(anchorEl)}
              onClose={handleClose}
            >
              <MenuItem onClick={handleNav}>My Profile</MenuItem>
              <MenuItem onClick={handleLogout}>Logout</MenuItem>
            </Menu>
          </Box>
        </Toolbar>
      </AppBar>
    </Box>
  );
};

export default NavBar;
